import { render } from "./Forecasting.vue?vue&type=template&id=016424c6&scoped=true&ts=true"
import script from "./Forecasting.vue?vue&type=script&lang=ts"
export * from "./Forecasting.vue?vue&type=script&lang=ts"

import "./Forecasting.vue?vue&type=style&index=0&id=016424c6&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016424c6"]])

export default __exports__